import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { GeneralService } from 'src/app/services/general.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import { NavigationExtras, Router } from '@angular/router';
import { MapInformationService } from 'src/app/services/map-information.service';
import { NewCustomerComponent } from '../new-customer/new-customer.component';
import { TranslateService } from '@ngx-translate/core';
import Popup from 'devextreme/ui/popup';
@Component({
  selector: 'app-new-service-site',
  templateUrl: './new-service-site.component.html',
  styleUrls: ['./new-service-site.component.scss']
})
export class NewServiceSiteComponent implements OnInit {
  @Output() result = new EventEmitter();
  @Output() cloeModal = new EventEmitter();
  @Input() popupServiceSite:boolean
  @Input() VieneDe:any
  @ViewChild('newcustomer', { static: false }) newcustomer: NewCustomerComponent;

  public _formEntity: FormGroup;
  IdAutocompleteOwner: number;
  optionsOwner: any;
  optionsMarket: any;
  optionsConutry: any;
  customerDataSource: any;
  owenername: any;
  direccion:any=""
  addCustomerButton:any
  popupCustomer:boolean=false
  cancelButtonNewCustomer: any;
  saveButtonNewCustomer: any;
  saveNewButtonNewCustomer:any
  saveEditButtonNewCustomer:any

  houseNumber:any=""
  street:any=""
  mapCity:any=""
  mapState:any=""
  mapcountry:any=""
  mapPaostalCode:any=""
  constructor(
    private MapInformationService:MapInformationService,
    private customerService: CustomerService,
    private generalService: GeneralService,
    private toast: ToastService,
    public fb: FormBuilder,
    private router: Router,
    private translate:TranslateService,
  ) {

    Popup.defaultOptions({
      device: { deviceType: "phone" },
      options: {
        fullScreen: true
      }
    });

    this.addCustomerButton = {
      icon: "plus",
      type: "button",
      onClick: () => {
        this.popupCustomer = true;
      },
    };

    this.cancelButtonNewCustomer = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupCustomer = false;
      },
    };

    this.saveButtonNewCustomer = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newcustomer.submitForm(true, false);
      },
    };

    this.saveNewButtonNewCustomer = {
      text: this.translate.instant('btnSaveNew'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newcustomer.submitForm(false, false);
      },

    };

    this.saveEditButtonNewCustomer = {
      text: this.translate.instant('btnSaveEdit'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newcustomer.submitForm(true, true);
      },
    };
  }

  ngOnInit() {
    this.initForm();
    this.getCountry();
    this.getMarket();
    // this.getOwner();

    let mythis = this;
    this.customerDataSource = new DataSource({
      load: function (loadOptions: any) {
        return mythis.customerService.GetCustomerByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }
  initForm() {
    this.owenername = '';
    this._formEntity = new FormGroup({
      sitename: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(50)]),
      siteaddress: new FormControl({ value: '', disabled: false }, []),
      siteaddressline2: new FormControl({ value: '', disabled: false }, []),
      sitecity: new FormControl({ value: '', disabled: false }, []),
      sitezip: new FormControl({ value: '', disabled: false }, []),
      sitecountry: new FormControl({ value: '', disabled: false }, []),
      sitestate: new FormControl({ value: '', disabled: false }, []),
      sitenotes: new FormControl({ value: '', disabled: false }, []),
      ownerid: new FormControl({ value: '', disabled: false }, [Validators.required]),
      sitevertcalmarket: new FormControl({ value: 1, disabled: false }, []),
      lon: new FormControl({ value: 0, disabled: false }, []),
      lat: new FormControl({ value: 0, disabled: false }, []),
      flagSale: new FormControl({ value: 0, disabled: false }, []),
    });
  }



  handleAddressChange(event){
    this.direccion = event.formatted_address
    this._formEntity.get('lon').setValue(event.geometry.location.lng());
    this._formEntity.get('lat').setValue(event.geometry.location.lat());
    this._formEntity.get('siteaddress').setValue(event.formatted_address);

    for (let i = 1; i < event.address_components.length; i++) {
      let test = event.address_components[i];
      console.log(test)
      if (test.long_name != '') {
        if (test.types[0] == "street_number") {
          this.houseNumber = test.long_name;
        }
        if (test.types[0] == "route") {
          this.street = test.long_name;
        }
        if (test.types[0] == "locality") {
          this.mapCity = test.long_name;
        }
        if (test.types[0] == "administrative_area_level_1") {
          this.mapState = test.short_name;
          // this.mapState = test.long_name;
        }
        if (test.types[0] == "country") {
          this.mapcountry = test.long_name;
        }
        if (test.types[0] == "postal_code") {
          this.mapPaostalCode = test.long_name;
        }
        let streets = this.street && this.houseNumber ? (this.houseNumber + ', ' + this.street) : '';
        test = streets ? streets : this.street;
      }
    }
    this._formEntity.get('sitecity').setValue(this.mapCity)
    this._formEntity.get('sitezip').setValue(this.mapPaostalCode)
    this._formEntity.get('sitecountry').setValue(this.mapcountry)
    this._formEntity.get('sitestate').setValue(this.mapState)

  }


  updateOwener(item) {

    if (item.selectedItem && item.selectedItem.ID) {
      this._formEntity.get('ownerid').setValue(item.selectedItem.ID);
      this.owenername = item.selectedItem.DESCRIPTION;
      // this.state = item.selectedItem.First + ' ' + item.selectedItem.Last;
    }
  }

  getOwner() {
    this.generalService.getPopulateGeneral('Customer/GetCustomerList').subscribe(
      data => {
        this.optionsOwner = data.map((val) => {
          return { // Return the new object structure
            Name: val.DESCRIPTION,
            ID: val.ID
          };
        });
      },
      err => {

      }
    )
  }

  getCountry() {
    this.customerService.GetCountries().subscribe(result => {
      this.optionsConutry = result.map((val) => {
        return { // Return the new object structure
          Name: val.COUNTYNAME,
          ID: val.CountryISO3
        };
      });
      // console.log('optionsConutry',this.optionsConutry);
    });
  }

  getMarket() {
    this.generalService.getPopulateGeneral('VerticalMarket').subscribe(result => {
      this.optionsMarket = result.map((val) => {
        return { // Return the new object structure
          Name: val.VERTMARKETDESCRIPTION,
          ID: val.ID
        };
      });
    });
  }

  closeModalOutput() {
    this.initForm();
    this.cloeModal.emit(true);

  }
  updateEmployeeInfo(e) {
    if (e.selectedItem) {
      this.IdAutocompleteOwner = e.selectedItem.ID;
    }
  }

  submitForm() {

    // if(this._formEntity.value.siteaddress != ''){
      let formValue;
      formValue = this._formEntity.value;
      if (formValue.sitename === '') {
        formValue.sitename = 'New Site'
      }
      if (this.IdAutocompleteOwner) {
        formValue.ownerid = this.IdAutocompleteOwner
      }

      if (formValue.lon == undefined || formValue.lon == '' ) {
        this.toast.warning("You must write the Address")
        return false
      }
      //save here
      
      formValue.method = "Insert_ServiceSiteCE"
      formValue.id = 0
      formValue.salesite = formValue.flagSale == true ? 1 : 0
      formValue.hascontract = 0
      formValue.hasasset = 0

      console.log("formValue", formValue);

      this.MapInformationService.getParameters("Insert_ServiceSiteCE")
      .subscribe(x=>{
        console.log(x)
      })

      this.MapInformationService.SaveInfoSites(formValue)
      .subscribe(data=>{
        console.log(data)
        this.toast.success(this.translate.instant('msgServSitCreSucc'));
        let resultdata: any;
        resultdata = { name: formValue.sitename, id: data[0].ReturnID }
        this.result.emit(resultdata);
        this.direccion = ""
        this.initForm();
        this.popupServiceSite = false
      })
  }

  submitFormEdit(){
    if(this._formEntity.value.siteaddress != ''){
      let formValue;
      formValue = this._formEntity.value;
      if (formValue.sitename === '') {
        formValue.sitename = 'New Site'
      }
      if (this.IdAutocompleteOwner) {
        formValue.ownerid = this.IdAutocompleteOwner
      }

      //save here
      console.log("formValue", formValue);
      // localStorage.removeItem('newSwoEdit')
      // localStorage.setItem('newSwoEdit',this.idNewSWO)

      this.generalService.postInsertUpdategeneral('Site/InsertSite', null, formValue).subscribe(
        data => {
          this.toast.success(this.translate.instant('msgServSitCreSucc'));
          let resultdata: any;
          resultdata = { name: formValue.sitename, id: data[0].ReturnID }
          this.direccion = ""
          localStorage.removeItem('newSite')
          localStorage.setItem('newSite',data[0].ReturnID)
          // let navigationExtras: NavigationExtras = {
          //   state: {
          //     numSITEID:data[0].ReturnID
          //   }
          // };
          // this.router.navigate(['/serviceSites/editServiceSite'], navigationExtras);
          this.router.navigate(['/serviceSites/editServiceSite'], { queryParams: { numSITEID: data[0].ReturnID} })
          // this.result.emit(resultdata);

          this.initForm();
          this.popupServiceSite = false
        },
        err => {
          console.log(err)
        }
      )
    } else {
      this.toast.warning("You have to write the address");
    }
  }

  close(){}

  resultulCustumerOriginal(ev) {
    console.log(ev);

    let obj = {
      selectedItem: {
        ID: ev.id,
        DESCRIPTION: ev.name
      }
    };

    this._formEntity.get("ownerid").setValue(ev.id)
    this.owenername = ev.name
  }

}
